import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const VideoIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="video-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className={twMerge('h-5 w-5 stroke-current', className)}
    {...props}
  >
  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" d="M22 6.4 17 8.6V6a1.7 1.7 0 0 0-1.7-1.7H2.6A1.7 1.7 0 0 0 .9 6v12a1.7 1.7 0 0 0 1.7 1.7h12.8a1.7 1.7 0 0 0 1.7-1.7v-2.6l4.9 2.2a.9.9 0 0 0 1.1-.8V7.2a.9.9 0 0 0-1.1-.8v0Z"/>
</svg>
)
